module.exports = __webpack_public_path__ + "46789d063a48b148ed93b39a39551279.svg";